var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.item.id)),_c('br'),_c('span',{staticClass:"text-gray-300"},[_vm._v(_vm._s(_vm.item.vehicle_id))])])}
var staticRenderFns = []

export { render, staticRenderFns }